import React from "react";
import LeftSec from "./LeftSec";
import ChatStartEndDay from "./ChatStartEndDay";
import RightSec from "./RightSec";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

function groupMessages(messages) {
  if (!messages || messages.length === 0) return [];

  const groupedByDate = [];
  let currentDate = messages[0]?.createdAt.split("T")[0];
  let currentDateGroup = {
    date: dayjs(currentDate).format("DD MMM YYYY"),
    message: [],
  };

  let currentUserGroup = {
    id: messages[0]?.user,
    user: messages[0]?.userInfo,
    message: [messages[0]],
  };

  for (let i = 1; i < messages.length; i++) {
    const msg = messages[i];
    const msgDate = msg.createdAt.split("T")[0];

    // If the message is on the same date
    if (msgDate === currentDate) {
      // Same user as previous?
      if (msg.user === currentUserGroup.id) {
        currentUserGroup.message.push(msg);
      } else {
        // Different user, push previous user group and start new
        currentDateGroup.message.push(currentUserGroup);
        currentUserGroup = { id: msg.user, user: msg.userInfo, message: [msg] };
      }
    } else {
      // Date changed, push last user group and date group
      currentDateGroup.message.push(currentUserGroup);
      groupedByDate.push(currentDateGroup);

      // Start new date group
      currentDate = msgDate;
      currentDateGroup = {
        date: dayjs(currentDate).format("DD MMM YYYY"),
        message: [],
      };
      currentUserGroup = { id: msg.user, user: msg.userInfo, message: [msg] };
    }
  }

  // Push remaining groups
  currentDateGroup.message.push(currentUserGroup);
  groupedByDate.push(currentDateGroup);

  return groupedByDate;
}

const ChatMessages = ({ messages }) => {
  const { session } = useSelector((state) => state?.authProvider);

  return groupMessages(messages || [])?.map((msgGroup, i) => (
    <React.Fragment key={i?.toString()}>
      <ChatStartEndDay dayTime={msgGroup?.date} />
      {console.log(msgGroup?.message)}
      {msgGroup?.message?.map((group, j) => (
        <React.Fragment key={j?.toString()}>
          {group?.user?._id === session?.user?._id ? (
            <>
              <RightSec group={group} />
              <div className="clear-both mb-2" />
            </>
          ) : (
            <>
              <LeftSec group={group} />
              <div className="clear-both mb-2" />
            </>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  ));
};

export default ChatMessages;
